import React from 'react';
import './directors-message.css';

const DirectorsMessage = () => {
  return (
    <div className="message-container">
      <h1>अध्यक्षांचे मनोगत</h1>
      <p>
        विशेष म्हणजे <strong>श्री लक्ष्मी महिला सबलीकरण योजना</strong> ही संस्था राबवत आहे. या योजनेअंतर्गत बचत गटांचे आयोजन करून महिला मेळाव्यांना
        उदंड प्रतिसाद मिळाला आहे. महिलांच्या व्यक्तिमत्व विकासासाठी व व्यवसाय मार्गदर्शनासाठी शिबिरांचे आयोजन केले जाते, ज्यामुळे महिलांच्या
        सबलीकरणाला चालना मिळत आहे.
      </p>
      <p>
        सहकाराला शिस्त आणि आधुनिक तंत्रज्ञानाची साथ मिळाली तर सर्वांगीण विकास सहज शक्य आहे. जिजाई अर्बन या संस्थेमध्ये याचा सुरेख संगम सर्वांना
        अनुभवायला मिळतोय. त्याचीच पावती म्हणून दिवसेंदिवस गतिशील होत असलेल्या संस्थेच्या प्रगतीतून मिळतेय. येणाऱ्या काळात बँकिंग मध्ये
        नवनवीन मानदंड प्रस्थापित करून ग्राहकाभिमुख सेवा देण्याकरिता आम्ही सज्ज आहोत आणि तुम्हीही अशाच विश्वासाने व प्रेमाने साथ द्याल हीच अपेक्षा.
      </p>
      <p>
        ग्राहकांना तत्पर सेवा देण्याकरिता सर्व कर्मचारी अहोरात्र कार्यरत आहे. तत्पर आणि ग्राहकाभिमुख सेवा देण्याकरिता आधुनिक तंत्रज्ञानाचा योग्य वापर
        केला जातो.
      </p>
    </div>
  );
};

export default DirectorsMessage;
